import { createDataTableFiltersContext } from "@/modules/common/context/data-table-filters.context";
import { InterestJourney, QueryInterestsSearchFilters } from "../types";

export const {
  Context: InterestssTableContext,
  useDataTableFiltersContext: useInterestsTableContext,
} = createDataTableFiltersContext<
  InterestJourney,
  QueryInterestsSearchFilters
>();
